import { memo } from 'react';

import { Icon } from '../icon';
import { Text } from '../text';
import { Tooltip } from '../tooltip';
import * as Styled from './button.styles';
import { ButtonProps } from './button.types';

const ButtonComponent = ({
	label,
	EndSvg,
	StartSvg,
	variant = 'contained',
	padding,
	size = 'full',
	isLoading = false,
	disabled,
	fill,
	tooltip = '',
	withTooltip = false,
	widthTooltip,
	fontSizeTooltip,
	paddingTooltip,
	...props
}: ButtonProps) => {
	const renderButton = () => (
		<Styled.Button
			variant={variant}
			size={size}
			padding={padding}
			disabled={disabled || isLoading}
			withTooltip={withTooltip}
			tooltip={tooltip}
			{...props}
		>
			{isLoading && <Styled.ButtonSpinner color="secondary" size="s" margin="0" />}
			{StartSvg && !isLoading && <Icon Svg={StartSvg} fill={fill || 'currentColor'} />}
			{label && <Text label={label} align="center" color="inherit" weight={500} cursor="pointer" />}
			{EndSvg && <Icon Svg={EndSvg} fill={fill || 'currentColor'} />}
		</Styled.Button>
	);

	if (withTooltip && tooltip) {
		return (
			<Tooltip
				className="tooltip-wrapper"
				direction="top"
				tooltip={tooltip}
				position="absolute"
				width={widthTooltip}
				fontSize={fontSizeTooltip}
				padding={paddingTooltip}
				boxSizing="border-box"
			>
				{renderButton()}
			</Tooltip>
		);
	}

	return renderButton();
};

export default memo(ButtonComponent);
